import React, {useCallback} from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {IconType} from 'types'
import {getAppStoreLink, getPlayStoreLink} from 'utils'
import {IMAGE_ASSET} from 'consts'
import {Icon, Image, Paragraph, RoboyuDefault} from 'common/components'
import convertUnit from 'lib/unit'
import {useSelector} from 'lib/redux'
import {GiftShopRobopetActivationTemplate} from '../ActivationTemplate'

const StyledRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${convertUnit(16)};
`

// const StyledButton = styled(Button)`
//   width: 100%;
// `

const StyledStoreImagesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: ${convertUnit(20)};
  gap: ${convertUnit(20)};
`

const StyledImg = styled(Image)`
  height: ${convertUnit(35)};
  width: ${convertUnit(100)};
  object-fit: contain;
`

const StyledLink = styled.a`
  text-decoration: none;
`

const StyledIcon = styled(Icon)`
  margin-right: ${convertUnit(20)};
`

const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

const StyledParagraph = styled(Paragraph)`
  text-align: center;
`

export default function GiftShopRobopetActivationUnregistered() {
  const {translate} = useTranslation()
  const {colorTheme} = useSelector('roboyuState')
  const googlePlayImg = IMAGE_ASSET('giftshop', 'google-play-icon.png')
  const appStoreImg = IMAGE_ASSET('giftshop', 'app-store-icon.png')

  const handleRenderDescriptionItems = useCallback(
    (icon: IconType) => (
      <StyledRowContainer>
        <StyledIcon type={icon} size={convertUnit(32)} color="white_1" />
        <Paragraph fontSize="m" fontWeight="medium" color="white_1">
          {translate('giftShop:roboyuActivationUnregisteredDescription', {
            context: icon,
          })}
        </Paragraph>
      </StyledRowContainer>
    ),
    [translate],
  )

  return (
    <GiftShopRobopetActivationTemplate
      backgroundColor="primary_5"
      robopetImg={
        <RoboyuDefault
          width={convertUnit(161)}
          height={convertUnit(174)}
          colorTheme={colorTheme.name}
        />
      }
      title={translate('giftShop:roboyuActivationUnregisteredHeader')}
      titleColor="white_1">
      <StyledContentContainer>
        {handleRenderDescriptionItems('search')}
        {handleRenderDescriptionItems('robopet')}
        {handleRenderDescriptionItems('filter-ol')}
        {handleRenderDescriptionItems('image-search')}
      </StyledContentContainer>
      <StyledParagraph color="white_1" fontWeight="bold" fontSize="m">
        {translate('giftShop:roboyuActivationUnregisteredDescription')}
      </StyledParagraph>
      <StyledStoreImagesContainer>
        <StyledLink href={getPlayStoreLink()} target="_blank">
          <StyledImg src={googlePlayImg} alt="google-play" />
        </StyledLink>
        <StyledLink href={getAppStoreLink()} target="_blank">
          <StyledImg src={appStoreImg} alt="app-store" />
        </StyledLink>
      </StyledStoreImagesContainer>
      {/* <StyledButton
        label={translate('global:next')}
        color="primary_5"
        backgroundColor="white_3"
        backgroundHoverColor="white_1"
        onClick={() => history.push('giftshop_robopet_activation_selfie', {})}
      /> */}
    </GiftShopRobopetActivationTemplate>
  )
}
